module.exports = __webpack_public_path__ + "img/抱拳.1c4741f5.png";